import { createAction } from '@reduxjs/toolkit';
import { site } from 'lib/src/shared/enums/site';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { ChallengeGroup } from 'src/types/shared/ChallengeGroup';

export const editChallengeGroupRequest = createAction('editChallengeGroupRequest');
export const editChallengeGroupSuccess = createAction<ChallengeGroup>('editChallengeGroupSuccess');
export const editChallengeGroupFailure = createAction('editChallengeGroupFailure');

export const editChallengeGroup = (id: number, postBody: PostBody) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(editChallengeGroupRequest());
    try {
        const { data } = await api.patch<PostBody, ChallengeGroup>(
            `admin/challengeGroups/${id}`,
            postBody,
        );

        dispatch(editChallengeGroupSuccess(data));
    } catch (e: any) {
        handleApiErrors(dispatch, editChallengeGroupFailure, e);
    }
};

type PostBody = {
    name: string;
    viewerIDs: number[];
    adminIDs: number[];
    site: site;
};
